export const AFFIDABILITA_ICON_NAME = 'verified_user'
export const USER_ICON_NAME = 'account_circle'
export const PLACE_ICON_NAME = 'place'
export const SWAPS_DONE_ICON_NAME = 'cached'
export const DENARO_ICON_NAME = 'euro_symbol'



// WEBPACK FOOTER //
// ./src/styles/icons.js